import {
  createRole as createRoleRequest,
  deleteRole as deleteRoleRequest,
  getRoleById as getRoleByIdRequest,
  getRoles as getRolesRequest,
  updateRole as updateRoleRequest,
} from "@/api/roles/roles-services";

export const fetchRoles = async () => {
  const data = await getRolesRequest();
  return Array.isArray(data) ? data : [];
};

export const fetchRoleById = async (id) => {
  return await getRoleByIdRequest(id);
};

export const createRole = async (payload) => {
  return await createRoleRequest(payload);
};

export const updateRole = async (id, payload) => {
  return await updateRoleRequest(id, payload);
};

export const deleteRole = async (id) => {
  return await deleteRoleRequest(id);
};

export default {
  fetchRoles,
  fetchRoleById,
  createRole,
  updateRole,
  deleteRole,
};
